var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalRunsFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    rx: 2.4,
    fill: "#FDF2EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86875 6.16875L7.61875 8.41875L9.85 10.65C10.0375 10.8187 10.0375 11.1 9.85 11.2687C9.68125 11.4562 9.4 11.4562 9.23125 11.2687L6.98125 9.0375L4.75 11.2687C4.58125 11.4562 4.3 11.4562 4.13125 11.2687C3.94375 11.1 3.94375 10.8187 4.13125 10.6312L6.3625 8.4L4.13125 6.16875C3.94375 6 3.94375 5.71875 4.13125 5.53125C4.3 5.3625 4.58125 5.3625 4.76875 5.53125L7 7.78125L9.23125 5.55C9.4 5.3625 9.68125 5.3625 9.86875 5.55C10.0375 5.71875 10.0375 6 9.86875 6.16875Z",
    fill: "#9F3415"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRunsFailed);
export default __webpack_public_path__ + "static/media/total-runs-failed.7564d3b08f85b6dce95cd111b0f94691.svg";
export { ForwardRef as ReactComponent };